import { VIDEO }                         from "_common/utils";
import { formatLiveSession }             from "_common/utils/broadcast";
import { getUserSessions }               from "_services/api/broadcast";
import { getReels, getUserUploadedFeed } from "_services/api/feed";
import { checkInProcessingUpload }       from "_services/api/upload";

export const tabList = [
	{ label: "Live", value: "live" },
	{ label: "Videos", value: "videos" },
	{ label: "Reels", value: "reels" },
	{ label: "Photos", value: "photos" }
];

export const formatUserSessions = ( list = [] ) => {
	return list.map ( item => formatLiveSession ( item ) );
};

export const formatUserUploadedFeed = ( list = [], val ) => {
	return list.map ( item => {
		const res = {
			id        : item?.id,
			createdAt : item?.createdAt,
			title     : item?.title,
			userData  : {
				id      : item?.actorDetails?.id,
				name    : item?.actorDetails?.name,
				photo   : item?.actorDetails?.photo,
				isCeleb : item?.actorDetails?.isCeleb
			},
			thumbnail     : item?.media?.find ( el => el?.mediaSequence === "2" )?.href || "",
			src           : item?.media?.find ( el => el?.mediaSequence === "3" )?.href || "",
			videoDuration : item?.read_time,
			views         : item?.views, // totalViews, views are already there, not confirm which one should be used
			feedType      : VIDEO
		};

		if ( val && item.id == val?.feedId ) {
			res.uploadStatus = {
				video: {
					 type: "video", feedId: val?.feedId, status: val?.status, userMessage: val?.userMessage
				}
			};
		}

		return res;
	}
	);
};

export const formatReels = ( list = [], val ) => {
	return list.map ( item => {
		const res = {
			id        : item?.id,
			createdAt : item?.createdAt,
			title     : item?.title,
			userData  : {
				id      : item?.actorDetails?.id,
				name    : item?.actorDetails?.name,
				photo   : item?.actorDetails?.photo,
				isCeleb : item?.actorDetails?.isCeleb
			},
			thumbnail     : item?.media?.find ( el => el?.mediaSequence === "2" )?.href || "",
			src           : item?.media?.find ( el => el?.mediaSequence === "3" )?.href || "",
			videoDuration : item?.read_time,
			views         : item?.views, // totalViews, views are already there, not confirm which one should be used
			feedType      : VIDEO
		};

		if ( val && item.id == val?.feedId ) {
			res.uploadStatus = {
				reel: {
					type: "reel", feedId: val?.feedId, status: val?.status, userMessage: val?.userMessage
				}
			};
		}

		return res;
	 } );
};

export const fetchTabData = async function ( props ) {

	const { id, tab, pageNo } = props;

	if ( !id && !tab ) return;

	let res         = {};
	let feedApiData = [];

	let params = {
		sportsFanId : id,
		pageNo      : pageNo,
		pageSize    : 10
	};

	switch ( tab ) {
		case tabList[0].value: {
			feedApiData = await getUserSessions.bind ( this ) ( params );
			feedApiData = formatUserSessions ( feedApiData );
			break;
		}

		case tabList[1].value: {
			params["type"] = "video";
			feedApiData    = await getUserUploadedFeed.bind ( this ) ( params );
			res            = await checkInProcessingUpload.bind ( this ) ( { contentType: "video" } );
			feedApiData    = formatUserUploadedFeed ( feedApiData, res );
			break;
		}

		case tabList[2].value: {
			feedApiData = await getReels.bind ( this ) ( params );
			res         = await checkInProcessingUpload.bind ( this ) ( { contentType: "reel" } );
			feedApiData =  formatReels ( feedApiData, res );
			break;
		}

		case tabList[3].value: {
			params["type"] = "image";
			feedApiData    = await getUserUploadedFeed.bind ( this ) ( params );
			break;
		}

		default:
			break;
	}

	return feedApiData;
};
